import React from 'react'
import { SearchIcon } from '../Icons'
import './index.sass'

const MarketsTableSearch = ({ search, isSearchOpen, onToggle, onChange, onBlur, onClear, inputRef }) => {
  const isVisible = isSearchOpen || search
  
  return (
    <div className="markets-table-search">
      <button 
        type="button" 
        className={`markets-table-search__toggle ${isVisible ? 'markets-table-search__toggle--open' : ''}`}
        aria-label="Toggle search" 
        onClick={onToggle}
      >
        <SearchIcon />
      </button>
      <div className={`markets-table-search__container ${isVisible ? 'markets-table-search__container--visible' : 'markets-table-search__container--hidden'}`}>
        <input
          ref={inputRef}
          type="text"
          value={search}
          onChange={onChange}
          onBlur={onBlur}
          className="markets-table-search__input"
          autoFocus={isVisible}
        />
        <button 
          type="button" 
          className="markets-table-search__cancel" 
          aria-label="Cancel search" 
          onClick={onClear}
        >
          Cancel
        </button>
      </div>
    </div>
  )
}

export default MarketsTableSearch

